import React from 'react'

const DoxFileIcon = () =>
    <svg width="88" height="108" viewBox="0 0 44 54" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M27.3346 0.333008H6.0013C3.06797 0.333008 0.694636 2.73301 0.694636 5.66634L0.667969 48.333C0.667969 51.2663 3.0413 53.6663 5.97463 53.6663H38.0013C40.9346 53.6663 43.3346 51.2663 43.3346 48.333V16.333L27.3346 0.333008ZM38.0013 48.333H6.0013V5.66634H24.668V18.9997H38.0013V48.333ZM11.3346 35.0263L15.0946 38.7863L19.3346 34.573V45.6663H24.668V34.573L28.908 38.813L32.668 35.0263L22.028 24.333L11.3346 35.0263Z" />
    </svg>

export default DoxFileIcon